import { Spin } from 'antd';
import { Suspense, lazy } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import Layout from '../../components/Layout';
import Menu from '../../components/Layout/Menu';

const TopicsContent = lazy(() => import('../../components/Pages/Topics'));

export default function Topics(): JSX.Element | null {
  document.title = `${process.env.REACT_APP_TITLE}: Topics List page`;

  return (
    <Layout LeftMenu={Menu} transparent>
      <Suspense fallback={<Spin spinning indicator={<LoadingOutlined spin />} />}>
        <TopicsContent />
      </Suspense>
    </Layout>
  );
}
